<script setup lang="ts">
import { useI18n } from 'vue-i18n';


const model = defineModel<boolean | null | undefined>({
    required: true
});

const props = withDefaults(
    defineProps<{
        name: string;
        readonly?: boolean;
        disabled?: boolean;
        row?: boolean;
        error?: string | null;
        yesText?: string;
        noText?: string;
    }>(),
    {
        row: true,
        readonly: false,
        disabled: false,
        yesText: () => useI18n().t('yes'),
        noText: () => useI18n().t('no')
    }
);

function onChange(ev: InputEvent) {
    const field = ev.target as HTMLInputElement;
    const val = field?.value as unknown;
    model.value = val === 'true' || val === true;
}
</script>

<template>
    <div>
        <div
            :class="{
                flex: true,
                'gap-2': true,
                'flex-row': row,
                'flex-column': !row
            }"
        >
            <ktg-labelled-choice>
                <ktg-radio
                    :input-id="`${name}-yes`"
                    :name="name"
                    :value="true"
                    :disabled="readonly || disabled"
                    :checked="model === true"
                    @change="onChange"
                />
                <ktg-label :for="`${name}-yes`">{{ props.yesText }}</ktg-label>
            </ktg-labelled-choice>
            <ktg-labelled-choice class="ml-1_5rem">
                <ktg-radio
                    :input-id="`${name}-no`"
                    :name="name"
                    :value="false"
                    :disabled="readonly || disabled"
                    :checked="model === false"
                    @change="onChange"
                />
                <ktg-label :for="`${name}-no`">{{ props.noText }}</ktg-label>
            </ktg-labelled-choice>
        </div>

        <ktg-field-error v-if="error" class="list-error-margin ktg-box-margin">{{ error }}</ktg-field-error>
    </div>
</template>
